<template>
	<div v-loading="loading" class="container">
		<div class="flex-row-center-between">
			<el-button type="text" v-if="!expandAll" @click="changeExpandStaus">
				<i class="el-icon-caret-right"></i>
				全部展开
			</el-button>
			<el-button type="text" v-else @click="changeExpandStaus">
				<i class="el-icon-caret-bottom"></i>
				全部收起
			</el-button>
			<el-checkbox v-model="checkAll" class="yx-color-primary allPower" @change="handleCheckAllChange" :indeterminate="isIndeterminate">
				所有权限
			</el-checkbox>
		</div>
		<el-tree
			v-bind="$attrs"
			:data="treeData"
			show-checkbox
			node-key="id"
			class="elTree"
			ref="treeNode"
			:check-strictly="false"
			highlight-current
			:props="treeProps"
			:default-expand-all="expandAll"
			@check="nodeChange"
			style="position: relative; right: 4px"
		>
			<span class="custom-tree-node" slot-scope="{ node, data }">
				<span>{{ node.label }}</span>
				<span v-show="isWhiteList(data.id)" class="warn-text"> （仅针对达人运营生效） </span>
			</span>
		</el-tree>
	</div>
</template>

<script>
import { getAllMenuPower } from '@/api/teamManage';
import { getDictDatas, DICT_TYPE } from '@/utils/dict';

export default {
	props: {
		value: [String, Number, Array],
		default: [],
	},
	watch: {
		value() {
			this.setNodeChecked();
		},
	},
	data() {
		return {
			expandAll: false,
			isIndeterminate: false,
			originList: [],
			loading: false,
			treeData: [],
			checkAll: false,
			curNodes: [],
			treeProps: {
				children: 'children',
				label: 'name',
			},
			noticeWhiteList: [],
		};
	},
	created() {
		this.getAllMenuPower();
		// this.noticeWhiteList = getDictDatas(DICT_TYPE.ONLY_TALENT_PERMISSION);
	},
	methods: {
		isWhiteList(id) {
			return this.noticeWhiteList.some(item => item.value == id);
		},
		//新增角色的时候获取所有的
		async getAllMenuPower() {
			this.loading = true;
			let { list, hideMenuList } = await getAllMenuPower({ hideMenu: 1 });
			const hideMenuObj = {};
			hideMenuList.forEach(item => {
				hideMenuObj[item] = true;
			});
			// 特有权限对象
			this.hideMenuObj = hideMenuObj;
			// 有效的特有权限对象 如果这个特有权限 是一个目录则不处理，有效的特有权限是这个特有权限是一个叶子节点
			this.hideMenuTree = {};

			// 将一维数组转换为树形结构
			this.treeData = this.arrayToTree(list, 0);
			// 重新过滤list 把有效的特有权限对象删除掉
			list = list.filter(item => !this.hideMenuTree[item.id]);
			this.originList = list;
			this.setNodeChecked();
			// 新增角色时关闭loading状态
			// 修改时关闭会导致二次loading的问题
			this.loading = false;
		},
		//转换一维数组成树形数组
		// 在原基础上 加入了查找叶子节点 如果是叶子节点 并且在特有权限内 则要隐藏这个特有权限
		arrayToTree(data, pid) {
			return data.length
				? data
						.filter(item => item.parentId === pid)
						.map(item => {
							const chil = this.arrayToTree(data, item.id);
							if (!chil.length && this.hideMenuObj[item.id]) {
								this.hideMenuTree[item.id] = true;
								return null;
							}
							return { ...item, children: chil };
						})
						.filter(item => item)
				: [];
		},
		changeExpandStaus() {
			this.expandAll = !this.expandAll;
			for (let i = 0; i < this.originList.length; i++) {
				this.$refs.treeNode.store.nodesMap[this.originList[i].id].expanded = this.expandAll;
			}
		},
		//节点发生改变时候的回调，需要和所有权限相互应
		nodeChange(obj, checkArr) {
			const { checkedKeys } = checkArr;
			// const checkedNodes = Array.from(new Set([...checkedKeys, ...halfCheckedKeys]));
			// this.ruleForm.menuIds = checkedNodes;
			// 设置全选复选框的半选中状态
			// 只有有选中项，且非全选才展示半选中状态
			this.isIndeterminate = checkedKeys.length > 0 && checkedKeys.length < this.originList.length;
			if (checkedKeys.length === this.originList.length) return (this.checkAll = true);
			this.checkAll = false;
			// this.$emit('input', checkedKeys);
		},
		//所有权限按钮
		handleCheckAllChange() {
			const checkedNodes = this.checkAll ? this.originList.map(item => item.id) : [];
			this.$refs.treeNode.setCheckedKeys(checkedNodes);
			// 全选或非全选状态下，设置半选中状态为false
			this.isIndeterminate = false;
			// this.$emit('input', checkedNodes);
		},
		reset() {
			this.$refs.treeNode.setCheckedKeys([]);
		},
		getCheckedKeys() {
			return this.$refs.treeNode.getCheckedKeys();
		},
		getHalfCheckedKeys() {
			return this.$refs.treeNode.getHalfCheckedKeys();
		},
		setNodeChecked() {
			if (!this.originList.length || !this.value.length) {
				this.$refs.treeNode.setCheckedKeys([]);
				this.checkAll = false;
				this.isIndeterminate = false;
				return;
			}
			this.$nextTick(() => {
				this.value.forEach(item => {
					if (this.$refs.treeNode.getNode(item)?.childNodes.length == 0) {
						this.$refs.treeNode.setChecked(item, true);
					}
				});
				this.checkAll = this.value.length > 0 && this.value?.length === this.originList.length;
				this.isIndeterminate = this.value.length > 0 && this.value?.length < this.originList.length;
			});
		},
	},
};
</script>

<style lang="less" scoped>
/deep/ .elTree .warn-text {
	color: @color-r;
}
</style>